export const splitDateRangeFacetKey = (str: string) => {
  return str.split(':');
};
